import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi, RequestType } from '@kapi';
import { EnvironmentVariablesService } from '@kenv';
import { DataStoreService } from '@kservice';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AnalyticsEvent } from './analytics-event.model';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsApi extends BaseApi {
  constructor(
    private client: HttpClient,
    public dataStoreService: DataStoreService,
    private _environmentVariablesService: EnvironmentVariablesService
  ) {
    super(client, dataStoreService, _environmentVariablesService);
  }

  async post(analytics: AnalyticsEvent): Promise<boolean> {
    const url = this.buildUrl('/analytics', true);
    return this.performRequest<boolean>(RequestType.POST, url, {
      requestBody: analytics.serialize(),
      includeToken: true,
    })
      .pipe(
        map((response: HttpResponse<boolean>): boolean => {
          return response?.ok;
        }),
        catchError((err): Observable<boolean> => {
          console.warn('failed posting analytics event: ', err);
          return of(false);
        })
      )
      .toPromise()
      .catch((error) => {
        console.warn(`Error posting analytics event: ${JSON.stringify(error)}`);
        return null;
      });
  }
}
